// extracted by mini-css-extract-plugin
export default {"input":"Input_input__wdWzm","input__center":"Input_input__center__f-kIV"};